import { graphql, useStaticQuery } from 'gatsby';

const useDigitIDProvidersQuery = (locale: string) => {
  const data = useStaticQuery(graphql`
    {
      providers: allContentfulDigitalId {
        nodes {
          node_locale
          digitId
          CPO
          EMP
          organization {
            companyName
            website
          }
        }
      }
    }
  `);

  const providersArr: {
    node_locale: string;
    digitId: string;
    CPO: boolean;
    EMP: boolean;
    organization: {
      companyName: string;
      website: string;
    };
  }[] = data.providers.nodes.filter(
    ({ node_locale }: { node_locale: string }) => node_locale === locale,
  );

  const providers = Object.values(
    providersArr.reduce(
      (
        acc: {
          [key: string]: {
            company: string;
            website: string;
            ID: string[];
            CPO: boolean[];
            EMP: boolean[];
          };
        },
        { digitId, CPO, EMP, organization: { companyName, website } },
      ) => {
        acc[companyName] = acc[companyName] ?? {
          company: companyName,
          website,
          ID: [],
          CPO: [],
          EMP: [],
        };
        acc[companyName].ID.push(digitId);
        acc[companyName].CPO.push(CPO);
        acc[companyName].EMP.push(EMP);

        return acc;
      },
      {},
    ),
  ).sort((a, b) =>
    a.company < b.company ? -1 : a.company > b.company ? 1 : 0,
  );

  return providers.length ? providers : null;
};

export default useDigitIDProvidersQuery;
